import React from 'react';
import { Button, Dialog, DialogTrigger, Popover } from 'react-aria-components';
import SvgIcon from '../../utils/SvgIcon';
interface DownloadDocsBulkProps {
  readonly placement?: 'bottom' | 'bottom start' | 'bottom end';
  readonly selectedRows: string[];
}

export default function DownloadDocsBulk({ placement = 'bottom', selectedRows }: Readonly<DownloadDocsBulkProps>) {
  const [isOpen, setIsOpen] = React.useState(false);
  const anyRowsSelected = selectedRows.length > 0;

  const handleBulkDownload = async (apiEndpoint: string) => {
    setIsOpen(false);
    try {
      const response = await fetch(`/api/downloads/${apiEndpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(selectedRows),
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error('Error response:', errorData);
        throw new Error('Download failed');
      }
    } catch (error) {
      console.error('Bulk download error:', error);
    }
  };

  return (
    <div className="bulk-download">
      {anyRowsSelected && <span className="bulk-download__selected-count">{selectedRows.length} selected:</span>}
      <DialogTrigger isOpen={isOpen} onOpenChange={setIsOpen}>
        <Button
          className="bulk-download__download-btn cta cta--secondary cta--small"
          aria-label="Download documents"
          isDisabled={!anyRowsSelected}
          type="button"
        >
          <SvgIcon iconName="download-medium" className="bulk-download__download-btn-icon icon" aria-hidden="true" />
          <span>Bulk download</span>
          <SvgIcon
            iconName={`nav-arrow-${isOpen ? 'up' : 'down'}-solid`}
            className="bulk-download__arrow-btn-icon icon"
            aria-hidden="true"
          />
        </Button>
        <Popover className="bulk-download__download-popover" placement={placement} shouldFlip={false}>
          <Dialog className="bulk-download__download-dialog">
            <Button
              className="bulk-download__download-link"
              type="button"
              onPress={() => handleBulkDownload('invoice/bulk/')}
            >
              Download invoices
            </Button>
            <Button
              className="bulk-download__download-link"
              type="button"
              onPress={() => handleBulkDownload('invoice/with-supporting/bulk/')}
            >
              Download all documents
            </Button>
          </Dialog>
        </Popover>
      </DialogTrigger>
      <div className="bulk-download__separator"></div>
    </div>
  );
}
